<template>
  <div class="form-textarea">
    <textarea v-model="model" />
  </div>
</template>

<script>
export default {
  name: 'ElementFormTextarea',
  data () {
    return {
      model: ''
    }
  },
  watch: {
    model: {
      deep: true,
      handler () {
        this.$emit('change', this.model)
      }
    }
  }
}

</script>

<style lang="scss">
  .form-textarea{}
</style>
